export default function haveFlightsBeenRemovedByTropics({
  flightsNotBookedFlagFromTropicsResponse,
  didRequestAmadeusFlights,
  didRequestPromisedFlights,
  tropicsBookingHasAmadeusFlights,
  tropicsBookingHasPromisedFlights,
} = {}) {
  if (typeof flightsNotBookedFlagFromTropicsResponse === 'boolean') {
    return (didRequestAmadeusFlights || didRequestPromisedFlights) && flightsNotBookedFlagFromTropicsResponse
  }

  const haveAmadeusFlightsBeenRemoved = Boolean(didRequestAmadeusFlights && !tropicsBookingHasAmadeusFlights)
  const havePromisedFlightsBeenRemoved = Boolean(didRequestPromisedFlights && !tropicsBookingHasPromisedFlights)

  return Boolean(haveAmadeusFlightsBeenRemoved || havePromisedFlightsBeenRemoved)
}